<ng-container *ngIf="formProperty.visible">
  <sf-widget-chooser
    (widgetInstanciated)="onWidgetInstanciated($event)"
    [widgetInfo]="formProperty.schema.widget">
  </sf-widget-chooser>
  <div class="form-element-footer">
    <sp-form-element-toast
      [toast]="toast"
      [formProperty]="formProperty">
    </sp-form-element-toast>
    <div class="form-element-actions">
      <sf-form-element-action
        *ngFor="let button of buttons"
        [button]="button"
        [formProperty]="formProperty">
      </sf-form-element-action>
    </div>
  </div>
</ng-container>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/formelement.component.html